(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coverage-calculator"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const areaInput = document.getElementById('area');
    const dropdown = document.getElementById('mat-type-dropdown');
    const trigger = dropdown.querySelector('.custom-select__trigger');
    const selectedLabel = dropdown.querySelector('.custom-select__selected');
    const options = dropdown.querySelectorAll('.custom-select__option');
    const result = document.getElementById('result');
    const resultValue = document.getElementById('result-value');
    const resultPrice = document.getElementById('result-price');
    const addToCartForm = document.getElementById('calc-add-to-cart');
    const idInput = addToCartForm.querySelector('input[name="id"]');
    const quantityInput = addToCartForm.querySelector('input[name="quantity"]');

    let selectedOption = null;

// Toggle open/close
    trigger.addEventListener('click', function() {
      dropdown.classList.toggle('is-open');
    });

// Close when clicking outside
    document.addEventListener('click', function(e) {
      if (! dropdown.contains(e.target)) {
        dropdown.classList.remove('is-open');
      }
    });

// Option selection
    options.forEach(function(option) {
      option.addEventListener('click', function() {
        options.forEach(function(o) {
          o.classList.remove('is-selected');
        });
        option.classList.add('is-selected');
        selectedLabel.textContent = option.textContent.trim();
        selectedOption = option;
        dropdown.classList.remove('is-open');
        calculate();
      });
    });

    function calculate() {
      const area = parseFloat(areaInput.value);

      if (! area || area <= 0 || ! selectedOption) {
        result.style.display = 'none';
        return;
      }

      const rate = parseFloat(selectedOption.dataset.value);
      const units = Math.ceil(area / rate);
      resultValue.textContent = units;
      result.style.display = 'flex';

      idInput.value = selectedOption.dataset.variantId;
      quantityInput.value = units;

      const priceEach = parseInt(selectedOption.dataset.variantPrice);
      const totalPrice = (priceEach * units) / 100;
      resultPrice.textContent = totalPrice.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    }

    areaInput.addEventListener('input', calculate);
  })();

  } catch(e) { console.error(e); }
})();
})();
